module.exports = {
	"id": "BB",
	"name": "Barbados",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": 0.00689,
			"11": 0.03445,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": 0.26182,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": 0.03445,
			"30": null,
			"31": 0.03445,
			"32": 0.00689,
			"33": 0.01378,
			"34": 0.02067,
			"35": 0.04134,
			"36": 0.02067,
			"37": 0.01378,
			"38": 0.08268,
			"39": 0.04823,
			"40": 0.03445,
			"41": 0.01378,
			"42": 0.01378,
			"43": 0.1378,
			"44": 0.04823,
			"45": 0.0689,
			"46": 0.03445,
			"47": 0.05512,
			"48": 0.02067,
			"49": 1.82585,
			"50": 0.10335,
			"51": 0.68211,
			"52": 0.35139,
			"53": 30.32978,
			"54": 6.91756,
			"55": 0.1378,
			"56": 0.04823,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": 0.00689,
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": 0.02067,
			"10": null,
			"11": 0.01378,
			"12": null,
			"13": 0.02067,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": 0.02067,
			"28": null,
			"29": null,
			"30": null,
			"31": null,
			"32": null,
			"33": null,
			"34": null,
			"35": null,
			"36": null,
			"37": 0.01378,
			"38": 0.02067,
			"39": 0.06201,
			"40": 0.04823,
			"41": null,
			"42": 0.02756,
			"43": 0.04823,
			"44": 0.04823,
			"45": 0.08957,
			"46": 0.04134,
			"47": 0.28249,
			"48": 0.29627,
			"49": 7.32407,
			"50": 0.24804,
			"51": null,
			"52": null,
			"3.5": null,
			"3.6": 0.01378
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": 0.01378,
			"28": null,
			"29": 0.0689,
			"30": null,
			"31": null,
			"32": null,
			"33": 0.02067,
			"34": null,
			"35": null,
			"36": 0.02067,
			"37": 0.24804,
			"38": 0.03445,
			"39": 0.00689,
			"40": 0.3445,
			"41": 0.0689,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": 0.00689,
			"12.1": 0.15158
		},
		"safari": {
			"0": null,
			"4": 0.04134,
			"5": 0.01378,
			"6": 0.02067,
			"7": 0.01378,
			"8": 0.11713,
			"9": 0.15847,
			"10": 1.39867,
			"3.1": null,
			"3.2": null,
			"5.1": 0.0689,
			"6.1": 0.02067,
			"7.1": 0.01378,
			"9.1": 0.88192
		},
		"ios_saf": {
			"8": 0,
			"10": 3.54189380516,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.0954499396336,
			"8.1-8.4": 0.176339718984,
			"9.0-9.2": 0.0841253705246,
			"9.3": 1.2834511657
		},
		"android": {
			"3": 0,
			"4": 0.0782283462532,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.00977854328165,
			"4.1": 0.282180820413,
			"4.2-4.3": 0.705452051034,
			"4.4": 1.61765044574,
			"4.4.3-4.4.4": 1.63161979328
		},
		"ie": {
			"6": null,
			"7": 0.0141020418204,
			"8": 0.387806150062,
			"9": 0.282040836408,
			"10": 0.211530627306,
			"11": 4.8370003444,
			"5.5": null
		},
		"op_mob": {
			"0": 0.0390342364553,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.00108428434598
		},
		"edge": {
			"12": 0.11713,
			"13": 0.9646,
			"14": 3.21763
		},
		"ie_mob": {
			"10": 0.133686197183,
			"11": 0.544293802817
		},
		"bb": {
			"7": 0.17105,
			"10": null
		},
		"samsung": {
			"0": 4.19228
		},
		"and_uc": {
			"0": 0.49449
		},
		"op_mini": {
			"0": 0.525901479199
		},
		"and_chr": {
			"0": 18.27913
		},
		"and_ff": {
			"0": 0.0311
		}
	},
	"total": 97.77474
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/BB.json
 ** module id = 472
 ** module chunks = 0
 **/